import { lazy, Suspense } from "react";
import { RouteObject, Redirect } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const AppItemsPage = lazy(() => import("./AppItemsPage"));
const NewItemPage = lazy(() => import("./NewItemPage"));
const ShowItemPage = lazy(() => import("./ShowItemPage"));
const EditItemPage = lazy(() => import("./EditItemPage"));
const ItemsExportPage = lazy(() => import("./ItemsExportPage"));

const appCreatorRoutes: RouteObject[] = [
  // Group-based app routes - redirects
  {
    path: "/groups/:groupSlug/apps/:appSlug",
    element: (
      <Redirect
        to={(params) =>
          `/groups/${params.groupSlug}/apps/${params.appSlug}/items`
        }
        replace={true}
      />
    ),
  },
  {
    path: "/groups/:groupSlug/apps/:appSlug/archive",
    element: (
      <Redirect
        to={(params) =>
          `/groups/${params.groupSlug}/apps/${params.appSlug}/items/archive`
        }
        replace={true}
      />
    ),
  },
  {
    path: "/groups/:groupSlug/apps/:appSlug/items",
    element: (
      <Suspense fallback={<Loading />}>
        <AppItemsPage />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/apps/:appSlug/items/archive",
    element: (
      <Suspense fallback={<Loading />}>
        <AppItemsPage isArchive />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/apps/:appSlug/items/new",
    element: (
      <Suspense fallback={<Loading />}>
        <NewItemPage />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/apps/:appSlug/items/exports",
    element: (
      <Suspense fallback={<Loading />}>
        <ItemsExportPage />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/apps/:appSlug/items/:itemId",
    element: (
      <Suspense fallback={<Loading />}>
        <ShowItemPage />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/apps/:appSlug/items/:itemId/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <EditItemPage />
      </Suspense>
    ),
  },
  // Network-level app routes - redirects
  {
    path: "/apps/:appSlug",
    element: (
      <Redirect
        to={(params) => `/apps/${params.appSlug}/items`}
        replace={true}
      />
    ),
  },
  {
    path: "/apps/:appSlug/archive",
    element: (
      <Redirect
        to={(params) => `/apps/${params.appSlug}/items/archive`}
        replace={true}
      />
    ),
  },
  {
    path: "/apps/:appSlug/items",
    element: (
      <Suspense fallback={<Loading />}>
        <AppItemsPage />
      </Suspense>
    ),
  },
  {
    path: "/apps/:appSlug/items/archive",
    element: (
      <Suspense fallback={<Loading />}>
        <AppItemsPage isArchive />
      </Suspense>
    ),
  },
  {
    path: "/apps/:appSlug/items/new",
    element: (
      <Suspense fallback={<Loading />}>
        <NewItemPage />
      </Suspense>
    ),
  },
  {
    path: "/apps/:appSlug/items/exports",
    element: (
      <Suspense fallback={<Loading />}>
        <ItemsExportPage />
      </Suspense>
    ),
  },
  {
    path: "/apps/:appSlug/items/:itemId",
    element: (
      <Suspense fallback={<Loading />}>
        <ShowItemPage />
      </Suspense>
    ),
  },
  {
    path: "/apps/:appSlug/items/:itemId/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <EditItemPage />
      </Suspense>
    ),
  },
];

export default appCreatorRoutes;
